import React from "react";
import "./pagestyles.css";
import Layout from "../components/Layout";

const Research = () => (
    <Layout>
        <></>
    </Layout>
)
  
export default Research